import { z } from 'zod';

/**
 * B-A.2.1 — типизированный currency code (SSOT совместно с `Currency` из enums.ts).
 * Локализация — `m.currency_{code}_symbol()` / `_name()`.
 */
export const CurrencyCode = z.enum(['KZT', 'USD', 'EUR', 'RUB', 'CNY']);
export type CurrencyCode = z.infer<typeof CurrencyCode>;
